import { useFoldersQuery } from "../navigation/use-navigation-data";
import type { FolderData } from "../types";
import { usePrivacySession } from "./use-privacy-session";

function findFolder(folders: FolderData[], id: string, parentPrivate = false): { folder: FolderData; isPrivate: boolean } | null {
  for (const folder of folders) {
    const isPrivate = parentPrivate || folder.privacy_enabled;
    if (folder.id === id) return { folder, isPrivate };
    const found = findFolder(folder.sub_folders ?? [], id, isPrivate);
    if (found) return found;
  }
  return null;
}

function containsPrivateFolder(folders: FolderData[]): boolean {
  return folders.some((folder) => folder.privacy_enabled || containsPrivateFolder(folder.sub_folders ?? []));
}

export function useFolderPrivacyStatus(folderId?: string) {
  const foldersQuery = useFoldersQuery();
  const { isUnlocked } = usePrivacySession();
  const match = folderId ? findFolder(foldersQuery.data?.folders ?? [], folderId) : null;
  const hasPrivateStub = containsPrivateFolder(foldersQuery.data?.folders ?? []);
  return {
    folder: match?.folder ?? null,
    isLocked: Boolean(folderId && !isUnlocked && (match?.isPrivate || (!match && hasPrivateStub))),
    isLoading: foldersQuery.isPending,
  };
}
